// use this as the source of truth for what the profile location string should look like
// if 'GB', try building [city] GB
// if US/state, try building [state] [city]
// if all location fields aren't supplied, build what we have
export default function buildProfileLocationString({ country, city, state }) {
  const locationParts = [];
  if (city) {
    locationParts.push(city);
  }
  if (country && country === 'GB') {
    locationParts.push(country);
  } else if (state) {
    locationParts.push(state);
  }
  return locationParts.join(' ');
}
